import { component } from 'picoapp';

export default component((node) => {
  class Quantity {
    constructor(element) {
      this.element = element;
      this.elements = this.getElements.call(this);

      this.quantity = this.elements.quantity.value;

      this.plusHandler = this.plusHandler.call(this);
      this.subtractHandler = this.subtractHandler.call(this);
    }

    setState() {
      if (this.elements.quantity.value > 1) this.elements.subtract.disabled = false;
      else this.elements.subtract.disabled = true;
    }

    plusHandler() {
      this.elements.add.addEventListener('click', (e) => {
        e.preventDefault();

        let val = Number(this.quantity);

        // eslint-disable-next-line no-multi-assign
        const newVal = val += 1;

        this.quantity = newVal;
        this.elements.quantity.setAttribute('value', newVal);

        this.setState();
      });
    }

    subtractHandler() {
      this.elements.subtract.addEventListener('click', (e) => {
        e.preventDefault();

        let val = Number(this.quantity);

        // eslint-disable-next-line no-multi-assign
        const newVal = val -= 1;

        this.quantity = newVal;
        this.elements.quantity.setAttribute('value', newVal);

        this.setState();
      });
    }

    getElements() {
      return {
        add: this.element.querySelector('[data-add]'),
        subtract: this.element.querySelector('[data-subtract]'),
        quantity: this.element.querySelector('input[name="quantity"]'),
      };
    }
  }

  // eslint-disable-next-line no-new
  new Quantity(node);
});
